import styled from 'styled-components'

export const Background = styled.div`
  width: 100vw;
  height: 100vh;
  height: 100dvh;
  position: fixed;
  z-index: 10000;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.colors.backgroundOverlay};
`

export const Video = styled.video`
  width: calc(100vw - 4rem);
  height: calc(100vh - 4rem);
  display: flex;
  justify-content: center;
  align-items: center;
`
